import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
    return {
        root: {
            border: '1px solid #fff',
            height: 8,
            width: 8,
            margin: 2,
            backgroundColor: '#000',
            borderRadius: '50%',
            display: 'inline-block',
            opacity: 0.7,
            [theme.breakpoints.up('sm')]: {
                height: 10,
                width: 10,
                margin: 4,
            },
            cursor: 'pointer',
            '@media print' : {
                display: 'none !important'
            }
        },
        active: {
            height: 8,
            width: 8,
            margin: 2,
            border: '1px solid #fff',
            backgroundColor: '#fff',
            borderRadius: '50%',
            display: 'inline-block',
            opacity: 1,
            [theme.breakpoints.up('sm')]: {
                height: 10,
                width: 10,
                margin: 4,
            },
            cursor: 'pointer',
            '@media print' : {
                display: 'none !important'
            }
        }
    }
});
export default function Circle(props) {
    const classes = useStyles();

    return (
        <div className={props.active ? classes.active : classes.root} onClick={props.onClick}></div>
    );
}
